import EditorRoutes from 'foundation/EditorRoutes';
import {ASSAY_TYPES} from 'results/assay-schemas/AssaySchemaConstants';
import {RouteBundle} from 'routing/RouteConstants';

export const ResultsRoutes: RouteBundle = {
  domain: 'results',
  routes: [
    {
      urlPattern: ':currentUserUrl/assay-schemas/requests/',
      handler: EditorRoutes.requestSchemas.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/requests/create',
      handler: EditorRoutes.requestSchemasCreate.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/requests/:assaySchemaId',
      handler: EditorRoutes.requestSchema.bind(EditorRoutes),
      legacy: true,
    },
    {urlPattern: ':currentUserUrl/assay-schemas/results/', handler: assayResultSchemas, legacy: true},
    {
      urlPattern: ':currentUserUrl/assay-schemas/results/create',
      handler: EditorRoutes.resultSchemaCreate.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/results/:assaySchemaId',
      handler: EditorRoutes.resultSchema.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/results/json/create',
      handler: assayResultSchemaCreateJson,
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/results/json/:assaySchemaId',
      handler: assayResultSchemaJson,
      legacy: true,
    },
    {urlPattern: ':currentUserUrl/assay-schemas/runs/', handler: assayRunSchemas, legacy: true},
    {
      urlPattern: ':currentUserUrl/assay-schemas/runs/create',
      handler: EditorRoutes.runSchemasCreate.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/runs/:assaySchemaId',
      handler: EditorRoutes.runSchema.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/runs/json/create',
      handler: assayRunSchemasCreateJson,
      legacy: true,
    },
    {
      urlPattern: ':currentUserUrl/assay-schemas/runs/json/:assaySchemaId',
      handler: assayRunSchemaJson,
      legacy: true,
    },
  ],
};

function assayResultSchemas(): void {
  EditorRoutes.assaySchemas(ASSAY_TYPES.ASSAY_RESULT);
}

function assayResultSchemaCreateJson(): void {
  EditorRoutes.assaySchemasCreate(ASSAY_TYPES.ASSAY_RESULT);
}

function assayResultSchemaJson(ownerUrlId: string, resultSchemaId: string): void {
  EditorRoutes.assaySchema(ASSAY_TYPES.ASSAY_RESULT, ownerUrlId, resultSchemaId);
}

function assayRunSchemas(): void {
  EditorRoutes.assaySchemas(ASSAY_TYPES.ASSAY_RUN);
}

function assayRunSchemasCreateJson(): void {
  EditorRoutes.assaySchemasCreate(ASSAY_TYPES.ASSAY_RUN);
}

function assayRunSchemaJson(ownerUrlId: string, runSchemaId: string): void {
  EditorRoutes.assaySchema(ASSAY_TYPES.ASSAY_RUN, ownerUrlId, runSchemaId);
}
